import { sql } from 'drizzle-orm'
import { char, datetime, int, mysqlTable, text, varchar } from 'drizzle-orm/mysql-core'
import { createSelectSchema } from 'drizzle-zod'

export const userTable = mysqlTable('GT_USER', {
  id: int('ID').autoincrement().notNull(),
  userId: varchar('USER_ID', { length: 50 }),
  userPw: varchar('USER_PW', { length: 100 }),
  name: varchar('NAME', { length: 50 }).notNull(),
  realNameEnc: text('REAL_NAME_ENC'),
  phoneEnc: text('PHONE_ENC'),
  phoneBidx: char('PHONE_BIDX', { length: 32 }),
  phoneLast4: char('PHONE_LAST4', { length: 4 }),
  emailEnc: text('EMAIL_ENC'),
  emailBidx: char('EMAIL_BIDX', { length: 32 }),
  credit: int('CREDIT').default(0).notNull(),
  createDate: datetime('CREATE_DATE', { mode: 'string' })
    .default(sql`(CURRENT_TIMESTAMP)`)
    .notNull(),
  lastloginDate: datetime('LASTLOGIN_DATE', { mode: 'string' }),
  kakaoId: varchar('KAKAO_ID', { length: 350 }),
  kakaoVerified: int('KAKAO_VERIFIED'),
  pathProfileThumb: varchar('PATH_PROFILE_THUMB', { length: 500 }),
  pathProfileOrigin: varchar('PATH_PROFILE_ORIGIN', { length: 500 }),
  deviceToken: varchar('DEVICE_TOKEN', { length: 500 }),
  deviceTokenVerified: int('DEVICE_TOKEN_VERIFIED').default(0),
  otp: varchar('OTP', { length: 4 }),
  recommendCode: varchar('RECOMMEND_CODE', { length: 5 }),
  recommendYn: varchar('RECOMMEND_YN', { length: 1 }).default('0'),
  accessToken: varchar('ACCESS_TOKEN', { length: 500 }),
  deviceType: varchar('DEVICE_TYPE', { length: 2 }),
  alarmYn: varchar('ALARM_YN', { length: 2 }).default('Y'),
  marketingYn: varchar('MARKETING_YN', { length: 2 }).default('Y'),
  walletId: varchar('WALLET_ID', { length: 32 }),
  memo: varchar('MEMO', { length: 2000 }),
  referralType: varchar('REFERRAL_TYPE', { length: 100 }),
  referralDetail: varchar('REFERRAL_DETAIL', { length: 500 }),
  ban: varchar('BAN', { length: 100 }),
  newYn: varchar('NEW_YN', { length: 2 }).default('Y'),
  companyCode: varchar('COMPANY_CODE', { length: 50 }),
  companyTeam: varchar('COMPANY_TEAM', { length: 50 }),
  deptName: varchar('DEPT_NAME', { length: 50 }),
  positName: varchar('POSIT_NAME', { length: 50 }),
  empNo: varchar('EMP_NO', { length: 50 }),
  govCompanyName: varchar('GOV_COMPANY_NAME', { length: 100 }),
  govCode: varchar('GOV_CODE', { length: 50 }),
  govManager: varchar('GOV_MANAGER', { length: 10 }),
  useYn: char('USE_YN', { length: 1 }).default('Y'),
  langType: varchar('LANG_TYPE', { length: 50 }).default('EN'),
  providerType: varchar('PROVIDER_TYPE', { length: 45 }),
  roleType: varchar('ROLE_TYPE', { length: 10 }).default('0'),
  refreshToken: varchar('REFRESH_TOKEN', { length: 256 }),
  genderEnc: text('GENDER_ENC'),
  ageRangeEnc: text('AGE_RANGE_ENC'),
  birthYearEnc: text('BIRTH_YEAR_ENC'),
  classType: varchar('CLASS_TYPE', { length: 50 }).default('PODO'),
  studentMemo: text('STUDENT_MEMO'),
})

export const selectUserSchema = createSelectSchema(userTable)
